import styled from 'styled-components'

export const PublicProgramContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-left: 10em;
  width: 100%;
`

export const PublicProgramTitle = styled.h6`
  margin: 0;
  margin-top: 66px;
  font-size: 28px;
  line-height: 28px;
  color: #1600ff;
  font-family: 'Work Sans';
`

export const PublicProgramDates = styled.p`
  color: gray;
`

export const PublicProgramContent = styled.div``

export const PublicProgramBody = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  position: relative;
`

export const PublicProgramCopySection = styled.span`
  display: flex;
  align-items: center;
`

export const PublicProgramCopyMsg = styled.span`
  color: #1600FF;
  margin-left: 20px;
`

export const PublicProgramItem = styled.div`
  margin: 5px;
`
export const PublicProgramItemTitle = styled.p`
  font-size: large;
`

export const PublicProgramItemContent = styled.div`
  display: flex;
`

export const PublicProgramItemContainer = styled.div`
  margin: 4px;
  width: 100%;
`